import { render, staticRenderFns } from "./RDCdissociated.vue?vue&type=template&id=fc3a862c&scoped=true&"
import script from "./RDCdissociated.vue?vue&type=script&lang=js&"
export * from "./RDCdissociated.vue?vue&type=script&lang=js&"
import style0 from "./RDCdissociated.vue?vue&type=style&index=0&id=fc3a862c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3a862c",
  null
  
)

export default component.exports